import * as React from 'react';
import { observer } from 'mobx-react';
import Loader from '../../../../Loader';
import LearningCollectionStore from '../../Store';
import ChooseProductLicenseReady from './ChooseProductLicenseReady';

interface Props {
  store: LearningCollectionStore;
}

const ChooseProductLicenseState: React.FC<Props> = ({ store }) => {
  switch (store.productLicensesStore.state.kind) {
    case 'waiting':
    case 'loading':
      return <Loader />;
    case 'error':
      return <></>;
    case 'ready':
      return (
        <ChooseProductLicenseReady
          store={store}
          productLicensesResource={store.productLicensesStore.state.productLicensesResource}
        />
      );
  }
};

export default observer(ChooseProductLicenseState);
